define('views/blocks/ListingMainView',['underscore', 'jquery', 'backbone', 'app', 'SubView', 'ProductBlockView', 'template!blocks/product-block', 'BannerCategoryView', 'template!blocks/banner-category', 'CSS3Events'],
    function (_, $, Backbone, app, SubView, ProductBlockView, productBlockTemplate,BannerCategoryView, bannerCategoryTemplate, CSS3Events) {

        //
        // Listing Main View
        // représente le bloc central, contenant tous les produits de tous les groupes
        //

        var view,
            // attention, cette vue est instanciée de manière unique par la page Listing
            // toutes les références sont surchargées à chaque nouvelle instance de la vue
            categories,
            categoriesEl,
            menuWrapper,
            categoriesBoxModel = [],
            categorySelectorPrefix = '.category-',
            t,tx=0;

        var DATA_ATTR_MOBILE_DISPLAY = 'data-mobile-display';

        function L(o){
            tx++;
            o = o ? o : '-';
        }

        return Backbone.View.extend(SubView).extend({
            events: {
            },
            initialize: function (option) {
                //
                t = new Date().getTime(); tx=0;

                view = this; // unique instance
                //
                //L()
                categories = app.getCategories();
                if (option.isNavigationByDesire) {
                    categories = categories.navigationbyDesireCategories();
                } else {
                    categories = categories.menuCategories();
                }
                categoriesEl = view.$('.category');
                menuWrapper = $('.listing-menu-wrapper');
                view.subviews = [];


                view.listenTo(app, 'resize', view.onResize);
                view.listenTo(app, 'scroll', view.onScroll);
                view.listenTo(app, 'listingFilterChange', view.onFilterChange);
                view.listenTo(app, 'displayCategory', view.displayCategory);
                view.listenTo(app.getCart(), 'deliveryUpdate changeContext changeCheckoutMode', view.onCartChangeContext);
                view.listenTo(app.getCustomer(), 'login logout', view.onCartChangeContext);
                //
                if(app.isMobile()){
                    view.listenTo(app, 'change:cartMobileState change:scrollLocked', view.cartMobileStateChange);
                }
                //
                var devaticsCategory = app.getCategoryDevatics();
                view.listenTo(devaticsCategory, 'change:products devaticsFail', view.onUpdateDevaticsCategoryProducts);
                //
                view.contextualRender();
                view.onScroll(null, app.get('scrollTop'));
            },

            render: function (isNavigationByDesire) {
                view.onResize();
            },

            onResize: function (e) {
                //L('onResize')
                view.updateBlocksDimensions();
                //L('updateBlocksDimensions complete')
                view.onScroll(e, app.get('scrollTop'));
                //L('onScroll')
            },

            onScroll: function (e, scrollTop) {
                if ((app.isDesktop()) && (!app.get('scrollLocked'))) {
                    var id_category = false,
                        winH = app.get('winH') || 400,
                        offsetTop = false,
                        scrollBottom = scrollTop + winH;
                    // on cherche à déterminer quel est la derniere category au dessus du scroll
                    _(categoriesBoxModel).each(function (box, index) {
                        if(offsetTop === false && box.top !== Infinity){
                            offsetTop = box.top;
                        }
                        if (box.top <= scrollTop + winH/2 - (offsetTop || 0) ) {
                            id_category = box.id_category.toString();
                        }
                        if(!box.loaded && box.top<(scrollBottom+(offsetTop||0)) && box.bottom>scrollTop+(offsetTop||0)){
                            // si le block est seulement préchargé, on le charge
                            box.loaded = true;
                            view.loadCategoryBlock(box.id_category);
                        }
                    });

                    // Set active category
                    if (id_category && id_category != view.id_category) {
                        app.trigger("listingScrollToCategory", view.id_category = id_category);
                    }

                }
            },

            loadCategoryBlock:function(id_category){
                //
                // charge la catégorie avec le template définitif et les vues Product Block
                //
                var catEl = view.$(categorySelectorPrefix+id_category),
                    cat = categories.get(catEl.data('id')),
                    list = '',
                    devaticsStrategyId = cat ? cat.get('devaticsStrategyId'): '',
                    isDevatics = !!devaticsStrategyId,
                    isLogged = app.getCustomer().isLogged(),
                    cart = app.getCart();

                // si elle est factuellement déjà chargée, ou pas encore synchronisée on ne la recharge pas
                // si la catégorie est introuvable on ignore
                if(!cat || catEl.is('.ready') || !cat.isSync) return;

                catEl.addClass('ready');
                cat.getElements(cart).each(function(element){
                    list += element.get('id_banner')
                    ? bannerCategoryTemplate({
                        isLogged:isLogged,
                        banner:element,
                        mobileImageFormat:'listing',
                        category:cat,
                        cart: cart
                    })
                    : productBlockTemplate({
                        isLogged:isLogged,
                        product:element,
                        className:'mobile-inline s-size',
                        mobileImageFormat:'listing',
                        wrapCol:true,
                        category:cat,
                        cart: cart
                    })
                });
                catEl.find('ul').html(list);
                if(isDevatics){
                    catEl.find('.product-block').attr('data-devatics-strategy',devaticsStrategyId);
                }
                view.attachViews(ProductBlockView.initializeProductBlocksOfEl(catEl));
                view.attachViews(BannerCategoryView.initializeBannercategoryOfEl(catEl));
            },

            displayCategory: function (id_category) {

                //L('displayCategory')
                var category = view.$(categorySelectorPrefix + id_category),
                    // calcul de l'offset en direct, si on est sur le premier element, on ajoute la hauteur des filtres
                    offsetTop = view.$el.offset().top + (category.index() == 0 ? view.$('.list-filters').outerHeight() : 0),
                    otherCats = category.siblings(),
                    isListingAllCategories = app.get('isListingAllCategories');

                if (app.isDesktop()) { // Desktop action

                    if (_.isUndefined(id_category)) {
                        return;
                    }
                    if (!_.isUndefined(category) && category.offset()) {
                        if( category.isSync ){
                            view.loadCategoryBlock(id_category);
                        }
                        app.scrollTop(category.offset().top - offsetTop);
                    }

                } else { // Mobile action

                    app.$htmlBody.css({overflow: 'hidden'});


                    if (!isListingAllCategories) { // affichage d'une category

                        view.loadCategoryBlock(id_category);

                        if (!menuWrapper.hasClass('active')) {

                            otherCats.addClass('inactive');
                            category.css({top: category.offset().top - app.get('scrollTop')}).addClass('selected');
                            category.removeClass('selected').addClass('active').attr(DATA_ATTR_MOBILE_DISPLAY,'visible');
                                category.css({top: 0, height: category.find('ul').height() + 240});
                                    otherCats.removeClass('inactive active').attr(DATA_ATTR_MOBILE_DISPLAY,'hidden');
                                    category.css({top: ''});
                                    app.$htmlBody.css({overflow: ''}).scrollTop(0);

                        } else {

                            category.addClass('no-transition active')
                                .removeClass('inactive selected')
                                .attr(DATA_ATTR_MOBILE_DISPLAY,'visible')
                                .css({height: category.find('ul').height() + 240})
                                .siblings()
                                .removeClass('selected active')
                                .addClass('inactive')
                                .attr(DATA_ATTR_MOBILE_DISPLAY,'hidden');
                            app.$htmlBody.css({overflow: ''}).scrollTop(0);
                            category.removeClass('no-transition');

                        }
                        menuWrapper.addClass('active');

                    } else { // Retour à la liste des catégories

                        categoriesEl.removeClass('selected inactive active').css({height: '', top: ''});//.show();
                        categoriesEl.filter('.hide').attr(DATA_ATTR_MOBILE_DISPLAY,'hidden');
                        categoriesEl.filter(':not(.hide)').attr(DATA_ATTR_MOBILE_DISPLAY,'visible');
                        menuWrapper.removeClass('active');
                        // mobileTop.removeClass('inactive');
                        $('html, body').css({overflow: ''}).scrollTop(0);

                    }

                }

            },

            cartMobileStateChange:function(){
                  if(!app.get('isListingAllCategories') && !app.get('scrollLocked')){
                      var category = this.$('.category.active');
                      this.updateMobileActiveCategory(category);
                  }
            },

            updateMobileActiveCategory:function(category){
                if(category && !!category.offset()) {
                    category.css({top: category.offset().top - app.get('scrollTop')}).addClass('selected');
                    category.css({top: 0, height: category.find('ul').height() + 240});
                    category.removeClass('selected').addClass('active').attr(DATA_ATTR_MOBILE_DISPLAY, 'visible');
                    category.css({top: ''});
                }
            },

            onCategoryChange: function (id_category, direction) {
                //var category = view.$(categorySelectorPrefix + id_category);
                // calcul de l'offset en direct, si on est sur le premier element, on ajoute la hauteur des filtres
                //view.updateBlocksDimensions();
            },

            onFilterChange:function(){
                view.contextualRender();
            },

            onDevaticsFail:function(devaticsCategory){
            },

            onUpdateDevaticsCategoryProducts:function(devaticsCategory){
                if(devaticsCategory){
                    var categoryWrapper = view.$(categorySelectorPrefix+devaticsCategory.id),
                        rawHtml = '',
                        isLogged = app.getCustomer().isLogged(),
                        products = devaticsCategory.getProducts(),
                        activeInContext = devaticsCategory.isActiveInContext();
                    //
                    //
                    products.each(function(product){
                        rawHtml += productBlockTemplate({
                            isLogged:isLogged,
                            product:product,
                            className:'mobile-inline s-size',
                            wrapCol:true,
                            mobileImageFormat:'line',
                            category:devaticsCategory,
                            cart: app.getCart()
                        });
                    });
                    categoryWrapper.find('ul').addClass('product-list__wrapper').html(rawHtml);
                    if(app.isDesktop()){
                        categoryWrapper.attr({
                            'data-block':devaticsCategory.get('devaticsStrategyId'),
                            'data-reco':devaticsCategory.get('devaticsRecoId')
                        }).addClass('dvt-reco');
                        categoryWrapper.toggleClass('hide',!activeInContext)
                            .attr(DATA_ATTR_MOBILE_DISPLAY,activeInContext?'visible':'hidden');

                        view.contextualRender();
                    }
                }
            },

            onCartChangeContext: function () {
                view.contextualRender();
            },

            contextualRender: function () {
                //L('contextualRender');
                // affiche et cache des catégories en fonction du context
                // (... context de livraison, filtres, etc)

                // TODO app.getCart()
                var cart = app.getCart(),
                    scrollTop = app.get('scrollTop'),
                    winH = app.get('winH'),
                    isListingAllCategories = app.get('isListingAllCategories');
                //
                if(!isListingAllCategories && app.isMobile()){
                    // sur mobile, on ne rend pas les catégories quand on est sur une categorie
                    return;
                }
                categories.each(function (category) {
                    var sel = categorySelectorPrefix + category.id,
                        catEl = view.$(sel),
                        offsetTop,
                        offset,
                        activeInContext = category.isActiveInContext(true,cart);
                    if(category.isSync) {
                        catEl.toggleClass('hide',!activeInContext)
                            .attr(DATA_ATTR_MOBILE_DISPLAY,activeInContext?'visible':'hidden')
                            .removeClass('ready');
                        category.getProducts().each(function(product){
                            var productsSel = '#cat-'+category.id+'-product-'+product.id,
                                productEl = view.$(productsSel+','+productsSel+' .product-block'),
                                isVisibleInContext = product.isVisibleInContext(true,cart);
                            productEl.toggleClass('active',isVisibleInContext)
                                .toggleClass('inactive',!isVisibleInContext);
                        });
                        // si le bloc est visible et qu'il est dans la zone de scroll
                        offset = catEl.offset();
                        offsetTop = offset ? offset.top : false;
                        if(offsetTop && (offsetTop> scrollTop) && (offsetTop<scrollTop+winH)){
                            // le bloc est visible
                            // donc on l'affiche
                            view.loadCategoryBlock(category.id);
                        }
                    }
                });

                view.updateBlocksDimensions();

                view.onScroll();
            },

            updateBlocksDimensions: function () {
                //L('updateBlocksDimensions');
                var offsetTop = view.$el.offset().top + view.$('.list-filters').outerHeight(), winH = app.get('winH');
                delete categoriesBoxModel;
                    categoriesBoxModel = [];
                // met à jour les dimensions des blocs
                categoriesEl.each(function (index, el) {
                    var $box = $(el), boxOffset = $box.offset(), boxHeight = $box.outerHeight(), boxTop = Math.round(boxOffset.top - offsetTop),box = {
                        // le top est mesuré en retirant les blocks le précédant
                        top: boxTop,
                        bottom: Math.round(boxHeight + boxTop),
                        id_category: $box.data('id').toString(),
                        height: boxHeight,
                        loaded: $box.is('.loaded')
                    };
                    if (box.top < 0 || !$box.is(':visible')) {
                        box.top = box.bottom = Infinity; // cas ou la boite est cachée
                    }
                    _(categoriesBoxModel).push(box);
                });
            }
        });
    });
